import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import MuiAvatar from '@material-ui/core/Avatar'
import useStyles from './styles'

const Avatar = props => {
  const { size, variant, children } = props
  const classes = useStyles()

  return (
    <MuiAvatar
      {...props}
      variant={variant}
      className={clsx(
        classes.root,
        size === 'medium' && classes.isMedium,
        size === 'large' && classes.isLarge,
      )}
    >
      {children}
    </MuiAvatar>
  )
}

Avatar.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node,
}

export default Avatar
